import { CREMATION_FUNERAL_PLAN_FEE } from 'config'

export const FUNERAL_PLANS_COMPETITOR_PRICES_LAST_UPDATED = 'April 2025'
export const DIRECT_CREMATION_COMPETITOR_PRICES_LAST_UPDATED = 'April 2025'
export const FUNERAL_PLANS_PROVIDER_FAREWILL = {
  name: 'Farewill',
  logotype: 'internal-logos/logo-farewill',
  price: CREMATION_FUNERAL_PLAN_FEE,
  highlighted: true,
}

export const FUNERAL_PLANS_PROVIDER_MEMORIA_FUNERALS = {
  name: 'Memoria Funerals',
  logotype: 'external-logos/logo-memoria-funerals',
  price: 1945,
}

export const FUNERAL_PLANS_PROVIDER_GOLDEN_CHARTER = {
  name: 'Golden Charter',
  logotype: 'external-logos/golden-charter-logo',
  price: 1785,
}

export const FUNERAL_PLANS_PROVIDER_PURE_CREMATION = {
  name: 'Pure Cremation',
  logotype: 'external-logos/logo-pure',
  price: 2095,
}

export const FUNERAL_PLANS_PROVIDERS = [
  FUNERAL_PLANS_PROVIDER_FAREWILL,
  FUNERAL_PLANS_PROVIDER_GOLDEN_CHARTER,
  FUNERAL_PLANS_PROVIDER_MEMORIA_FUNERALS,
  FUNERAL_PLANS_PROVIDER_PURE_CREMATION,
]
